// FILE: stratify_website/src/components/Link.jsx
import React from "react";
import { navigate } from "../lib/navigate";

function isModifiedEvent(e) {
  return e.metaKey || e.altKey || e.ctrlKey || e.shiftKey;
}

function isExternal(href) {
  return (
    /^https?:\/\//i.test(href) ||
    /^mailto:/i.test(href) ||
    /^tel:/i.test(href)
  );
}

export default function Link({
  to,
  href,
  onClick,
  disabled = false,
  className = "",
  children,
  ...rest
}) {
  const finalHref = (to || href || "/").toString();

  // Disabled should not be a real link (prevents bad SEO + weird routing)
  if (disabled) {
    return (
      <span
        className={className}
        aria-disabled="true"
        {...rest}
      >
        {children}
      </span>
    );
  }

  return (
    <a
      href={finalHref}
      className={className}
      onClick={(e) => {
        onClick?.(e);
        if (e.defaultPrevented) return;

        // Let browser handle new tabs, downloads, right click, etc.
        if (e.button !== 0) return;
        if (isModifiedEvent(e)) return;
        if (rest.target) return;

        // External links should use normal navigation
        if (isExternal(finalHref)) return;

        // Intercept internal navigation for SPA feel
        e.preventDefault();
        navigate(finalHref);
      }}
      {...rest}
    >
      {children}
    </a>
  );
}
